import {
  CREATE_ASSETS_CATEGORY,
  GET_ASSETS_CATEGORY,
  EDIT_ASSETS_CATEGORY,
  DELETE_ASSETS_CATEGORY,
  CREATE_ASSETS_STATUS,
  GET_ASSETS_STATUS,
  EDIT_ASSETS_STATUS,
  DELETE_ASSETS_STATUS,
  CREATE_ASSETS_FIELD,
  GET_ASSETS_FIELD,
  GET_SINGLE_ASSETS_FIELD,
  EDIT_ASSETS_FIELD,
  DELETE_ASSETS_FIELD,
  GET_ASSETS,
  GET_ASSETS_CATEGORY_WITH_FIELD,
  GET_SINGLE_ASSETS,
  EDIT_ASSETS,
  DELETE_ASSETS,
  IMPORT_ASSETS,
  EXPORT_SAMPLE_ASSET_CSV,
} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case GET_ASSETS_CATEGORY:
      return {
        ...state,
        getAssetsCategoryData: action.payload,
      }

    case GET_ASSETS_STATUS:
      return {
        ...state,
        getAssetsStatusData: action.payload,
      }

    case GET_ASSETS_FIELD:
      return {
        ...state,
        getAssetsFieldData: action.payload,
        getAssetsFieldPage: action.page,
      }

    case GET_ASSETS:
      return {
        ...state,
        getAssetsData: action.payload,
        getAssetsPage: action.page,
      }

    case GET_ASSETS_CATEGORY_WITH_FIELD:
      return {
        ...state,
        getAssetsCategoryWithFieldData: action.payload,
      }

    case CREATE_ASSETS_CATEGORY:
      return {
        ...state,
        getAssetsCategoryData: [action.payload, ...state.getAssetsCategoryData],
      }

    case CREATE_ASSETS_STATUS:
      return {
        ...state,
        getAssetsStatusData: [action.payload, ...state.getAssetsStatusData],
      }

    case CREATE_ASSETS_FIELD:
      return {
        ...state,
        getAssetsFieldData: [action.payload, ...state.getAssetsFieldData],
      }

    // case CREATE_ASSETS:
    //   return {
    //     ...state,
    //     getAssetsData: [action.payload, ...state.getAssetsData],

    //     getAssetsStatusData:
    //       state.getAssetsStatusData &&
    //       action.payload.statusId !== null &&
    //       !state.getAssetsStatusData.some(stat => stat.id === action.payload.statusId.id)
    //         ? [action.payload.statusId, ...state.getAssetsStatusData]
    //         : state.getAssetsStatusData,

    //     getAssetsCategoryWithFieldData:
    //       state.getAssetsCategoryWithFieldData &&
    //       action.payload.categoryId !== null &&
    //       !state.getAssetsCategoryWithFieldData.some(cate => cate.id === action.payload.categoryId.id)
    //         ? [action.payload.categoryId, ...state.getAssetsCategoryWithFieldData]
    //         : state.getAssetsCategoryWithFieldData,
    //   }

    case DELETE_ASSETS_CATEGORY: {
      return {
        ...state,
        getAssetsCategoryData: state.getAssetsCategoryData.filter(category => category.id !== action.payload.id),
      }
    }

    case DELETE_ASSETS_STATUS:
      return {
        ...state,
        getAssetsStatusData: state.getAssetsStatusData.filter(status => status.id !== action.payload.id),
      }

    case DELETE_ASSETS_FIELD:
      return {
        ...state,
        getAssetsFieldData: state.getAssetsFieldData.filter(field => field.id !== action.payload),
      }

    case DELETE_ASSETS:
      return {
        ...state,
        getAssetsData: state.getAssetsData.filter(field => field.id !== action.payload),
      }

    case EDIT_ASSETS_CATEGORY:
      return {
        ...state,
        getAssetsCategoryData: state.getAssetsCategoryData.map(category =>
          category.id === action.payload.id ? {...category, name: action.payload.name} : category
        ),
      }

    case EDIT_ASSETS_STATUS:
      return {
        ...state,
        getAssetsStatusData: state.getAssetsStatusData.map(status =>
          status.id === action.payload.id ? {...status, name: action.payload.name} : status
        ),
      }

    case EDIT_ASSETS_FIELD:
      return {
        ...state,
        getAssetsFieldData: state.getAssetsFieldData.map(field => {
          return field.id === action.payload.id ? {...action.payload} : field
        }),
      }

    case EDIT_ASSETS:
      return {
        ...state,
        getAssetsData: state?.getAssetsData?.map(asset => (asset.id === action.payload.id ? action.payload : asset)),
        getAssetsStatusData:
          state.getAssetsStatusData &&
          action.payload.statusId !== null &&
          !state.getAssetsStatusData.some(stat => stat.id === action.payload.statusId.id)
            ? [action.payload.statusId, ...state.getAssetsStatusData]
            : state.getAssetsStatusData,

        getAssetsCategoryWithFieldData:
          state.getAssetsCategoryWithFieldData &&
          action.payload.categoryId !== null &&
          !state.getAssetsCategoryWithFieldData.some(cate => cate.id === action.payload.categoryId.id)
            ? [action.payload.categoryId, ...state.getAssetsCategoryWithFieldData]
            : state.getAssetsCategoryWithFieldData,
      }

    case GET_SINGLE_ASSETS_FIELD:
      return {
        ...state,
        getSingleAssetsFieldData: action.payload,
      }

    case GET_SINGLE_ASSETS:
      return {
        ...state,
        getSingleAssetsData: action.payload,
      }

    case IMPORT_ASSETS:
      return {
        ...state,
        importData: action.payload,
      }

    case EXPORT_SAMPLE_ASSET_CSV:
      return {
        ...state,
        exportData: action.payload,
      }

    default:
      return {...state}
  }
}
